import { CaseServiceModel } from './case-service.model';

export class AddCaseServiceModel extends CaseServiceModel {

}
